<script>
import NotificationCount from '@/components/base/NotificationCount.vue';

export default {
  name: 'NotificationCountSingle',
  components: { NotificationCount },
  props: {
    query: Object,
  },
  observer: null,
  data() {
    return {
      notification: null,
    };
  },
  computed: {
    notifications() {
      const getter = this.$store.getters['notification/itemIdsByFilter'];
      return getter(this.query);
    },
  },
  watch: {
    notifications: {
      immediate: true,
      handler(val) {
        if (val.length) {
          this.notification = val[0]; // eslint-disable-line
        }
      },
    },
    notification: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$options.observer?.disconnect();
          return;
        }

        this.$nextTick(() => {
          const options = { threshold: 1 };
          this.$options.observer = new IntersectionObserver(this.observerCallback, options);
          this.$options.observer.observe(this.$el);
        });
      }
    },
  },
  methods: {
    observerCallback(entries) {
      entries.forEach(entry => {
        if (!entry.isIntersecting) return;
        if (!this.notification || this.notification.isLocallyViewed) return;

        this.$store.dispatch('notification/view', this.notification);
        this.notification.isLocallyViewed = true;
      });
    },
  },
}
</script>

<template lang="pug">
  //- тот же кружок, что и у счётчиков плиток; здесь он всегда «1»
  NotificationCount(v-if="notification" :count="1")
</template>

<style scoped lang="scss">
</style>
